/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Not_Found_BodyInputs */

const en_not_found_body = /** @type {(inputs: Not_Found_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This page does not exist or has moved.`)
};

const de_not_found_body = /** @type {(inputs: Not_Found_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Seite gibt es nicht oder sie wurde verschoben.`)
};

/**
* | output |
* | --- |
* | "This page does not exist or has moved." |
*
* @param {Not_Found_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const not_found_body = /** @type {((inputs?: Not_Found_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Not_Found_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_not_found_body(inputs)
	return en_not_found_body(inputs)
});